<template>
<div class="chapter">
<div class="inner_page">
<h1>Patina Farm</h1>
<div class="toc"><p><b>Table of Contents</b></p><dl>
<dt><span class="chapter"><a href="#/ch01">Foreword</a></span></dt>
<dt><span class="chapter"><a href="#/ch02">Introduction</a></span></dt>
<dt><span class="chapter"><span href="#/ch03" title="Link target outside of Sample">Arriving</span></span></dt>
<dt><span class="chapter"><span href="#/ch04" title="Link target outside of Sample">Connecting</span></span></dt>
<dt><span class="chapter"><span href="#/ch05" title="Link target outside of Sample">Nourishing</span></span></dt>
<dt><span class="chapter"><span href="#/ch06" title="Link target outside of Sample">Creating</span></span></dt>
<dt><span class="chapter"><span href="#/ch07" title="Link target outside of Sample">Restoring</span></span></dt>
<dt><span class="chapter"><span href="#/ch08" title="Link target outside of Sample">Rejuvenating</span></span></dt>
<dt><span class="chapter"><span href="#/ch09" title="Link target outside of Sample">Sharing</span></span></dt>
<dt><span class="chapter"><span href="#/ch10" title="Link target outside of Sample">Farming</span></span></dt>
<dt><span class="chapter"><span href="#/ch11" title="Link target outside of Sample">Resources</span></span></dt>
<dt><span class="chapter"><span href="#/ch12" title="Link target outside of Sample">Acknowledgments</span></span></dt>
</dl></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01toc.vue?3aa4be51